import templateUrl from './self.html'

/**
 * View own User route
 *
 * @namespace routes.AdminSelfFormList
 * @type {TmrRoute}
 */
export const route = {
  name: 'admin.self.list',
  url: '/self',
  label: 'ADMIN.SELF.TITLE',
  component: 'tmrSelfUser',
  resourceType: 'User',
  accessControl: [
    'Resource.edit',
    'Resource.SelfUser.list',
    'Resource.SelfUser.edit',
  ],
  resolve: {
    language: /*@ngInject*/ (tmrLanguages, loggedUser) =>
      tmrLanguages.languages[loggedUser.$getLanguage()]?.label,
  },
}

/**
 * View own User component.
 *
 * @type {ngComponent}
 */
export const tmrSelfUser = {
  ngType: 'component',
  templateUrl,
  bindings: {
    loggedUser: '<',
    language: '<',
  },
}
